export enum OrganizationMetadataFileTypeExtension {
    "XML_META" = 0,
    "JSON_META" = 1,
    "CSV_META_EXT" = 2,
    "JSON_META_EXT" = 3,
    "CSV_META" = 4
}
